var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-overlay",
    {
      attrs: {
        "z-index": 100,
        value: _vm.loadingStatus,
        color: "#183d65",
        opacity: "0.37"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "elevation-0",
          attrs: { flat: "", color: "transparent" }
        },
        [
          _c("v-responsive", [
            _c("img", {
              attrs: {
                width: "100",
                src: require("@/assets/images/loading-nobg.gif"),
                alt: "loading data"
              }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e397f0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e397f0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/ProgressDialog.vue
// module id = null
// module chunks = 